<template>
  <div class="company-profile-wrapper">
    <div class="tab-options">
      <button class="btn-add" @click="addMember()">
        <span> Add Member </span>
        <img src="@/assets/admin-icon/white-circle-plus.svg" />
      </button>
    </div>
    <!-- company-profile display -->
    <div
      class="company-profile-container"
      v-show="consultant_list == true"
      v-animate-css="'fadeIn'"
    >
      <multipane class="custom-resizer" layout="vertical">
        <div class="items">
          <div class="company-profile-body">
            <div class="tabs">
              <div
                class="tab"
                :class="{ active: main_tab == 'consultant' }"
                @click="main_tab = 'consultant'"
              >
                Consultants
              </div>
              <div
                class="tab"
                :class="{ active: main_tab == 'manager' }"
                @click="main_tab = 'manager'"
              >
                Managers
              </div>
            </div>

            <div
              class="search-add-btn-widget"
              v-if="
                tab == 'all'
                  ? user.consultants.length > 0
                  : user.available_consultants.length > 0 &&
                    main_tab == 'consultant'
              "
            >
              <div class="search-widget">
                <img src="@/assets/icons/search.svg" alt />
                <input
                  v-model="search_member_input"
                  @keyup="searchCompanyMember()"
                  type="text"
                  placeholder="Type in to Search…"
                />
              </div>
            </div>
            <div class="filter-widget" v-if="main_tab == 'consultant'">
              <div class="filter-select-widget">
                Filter by:
                <filter-select
                  v-model="selected_view_filter"
                  :content="view_filter"
                >
                  <div class="filter-selected-label">
                    <span v-if="tab == 'all'">All Consultant</span>
                    <span v-if="tab == 'avail'">Available consultant</span>
                  </div>
                </filter-select>
              </div>
            </div>

            <!-- For All Consultant -->
            <div
              v-if="tab == 'all' && main_tab == 'consultant'"
              class="list-container"
            >
              <table class="table-data">
                <thead class="table-header">
                  <tr>
                    <th>Consultant name</th>
                    <th>Availability</th>
                    <th>Contacts</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody class="table-body">
                  <template v-for="(item, index) in user.consultants">
                    <tr
                      :key="index"
                      :class="{ active: item.active }"
                      class="row-data"
                    >
                      <td @click="viewItem(item)">
                        <div class="profile-content center">
                          <img
                            class="profile-image"
                            v-if="item.profile_picture"
                            :src="
                              $fullUrl(
                                'images/profiles/' + item.profile_picture
                              )
                            "
                            alt
                          />

                          <div v-else class="profile-alphabet">
                            <span>{{
                              $nameInitials(
                                item.first_name + " " + item.last_name
                              ) | validate
                            }}</span>
                          </div>
                          <div class="names-location">
                            <label class="name"
                              >{{ item.first_name | validate }}
                              {{ item.last_name | validate }}</label
                            >
                            <span
                              class="location"
                              v-if="
                                item.profile &&
                                $validateData(item.profile.address)
                              "
                              >{{ item.profile.address | validate }}</span
                            >
                          </div>
                        </div>
                      </td>
                      <td @click="viewItem(item)">
                        <div
                          class="date"
                          v-if="$validateDateTime(item.profile.available_from)"
                        >
                          {{ item.profile.available_from | formatDate }}
                        </div>
                        <div class="date" v-else>Not Available</div>
                      </td>
                      <td @click="viewItem(item)">
                        <div class="email-phone">
                          <span class="email">{{ item.email | validate }}</span>
                          <span class="phone" v-if="item.profile">{{
                            item.profile.phone | validate
                          }}</span>
                        </div>
                      </td>
                      <td>
                        <div class="menu">
                          <!-- Dropdown -->
                          <dropdown-menu>
                            <ul>
                              <li>
                                <a
                                  href
                                  @click.prevent="
                                    showinviteManagerModal(item.id)
                                  "
                                  >Invite as Manager</a
                                >
                              </li>
                              <li>
                                <a
                                  href
                                  @click.prevent="manageConsultant(item.id)"
                                  >Manage Profile</a
                                >
                              </li>
                              <li>
                                <app-dialog
                                  title="Remove Consultant"
                                  ask="Are you sure? This consultant will be removed from the organization and will not be managed any further. To add the consultant again, a request needs to to be made to the consultant"
                                  yesText="Remove"
                                  noText="Cancel"
                                  @onComfirm="removeConsultant(item)"
                                >
                                  <a @click.prevent="">Remove consultant</a>
                                </app-dialog>
                              </li>
                            </ul>
                          </dropdown-menu>
                          <!-- End of dropdown -->
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <!-- For Available consultant -->
            <div
              v-if="tab == 'avail' && main_tab == 'consultant'"
              class="list-container"
            >
              <table class="table-data">
                <thead class="table-header">
                  <tr>
                    <th>Consultant name</th>
                    <th>Availability</th>
                    <th>Contacts</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody class="table-body">
                  <template v-for="(item, index) in user.available_consultants">
                    <tr
                      :key="index"
                      :class="{ active: item.active }"
                      class="row-data"
                    >
                      <td @click="viewItem(item)">
                        <div class="profile-content center">
                          <img
                            class="profile-image"
                            v-if="item.profile_picture"
                            :src="
                              $fullUrl(
                                'images/profiles/' + item.profile_picture
                              )
                            "
                            alt
                          />

                          <div v-else class="profile-alphabet">
                            <span>{{
                              $nameInitials(
                                item.first_name + " " + item.last_name
                              ) | validate
                            }}</span>
                          </div>
                          <div class="names-location">
                            <label class="name"
                              >{{ item.first_name | validate }}
                              {{ item.last_name | validate }}</label
                            >
                            <span
                              class="location"
                              v-if="
                                item.profile &&
                                $validateData(item.profile.address)
                              "
                              >{{ item.profile.address | validate }}</span
                            >
                          </div>
                        </div>
                      </td>
                      <td @click="viewItem(item)">
                        <div
                          class="date"
                          v-if="$validateDateTime(item.profile.available_from)"
                        >
                          {{ item.profile.available_from | formatDate }}
                        </div>
                        <div class="date" v-else>Not Available</div>
                      </td>
                      <td @click="viewItem(item)">
                        <div class="email-phone">
                          <span class="email">{{ item.email | validate }}</span>
                          <span class="phone" v-if="item.profile">{{
                            item.profile.phone | validate
                          }}</span>
                        </div>
                      </td>
                      <td>
                        <div class="menu">
                          <!-- Dropdown -->
                          <dropdown-menu>
                            <ul>
                              <li>
                                <a
                                  href
                                  @click.prevent="
                                    showinviteManagerModal(item.id)
                                  "
                                  >Invite as Manager</a
                                >
                              </li>
                              <li>
                                <a
                                  href
                                  @click.prevent="manageConsultant(item.id)"
                                  >Manage Profile</a
                                >
                              </li>
                              <li>
                                <app-dialog
                                  title="Remove Consultant"
                                  ask="Are you sure? This consultant will be removed from the organization and will not be managed any further. To add the consultant again, a request needs to to be made to the consultant"
                                  yesText="Remove"
                                  noText="Cancel"
                                  @onComfirm="removeConsultant(item)"
                                >
                                  <a @click.prevent="">Remove consultant</a>
                                </app-dialog>
                              </li>
                            </ul>
                          </dropdown-menu>
                          <!-- End of dropdown -->
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <!-- For manages -->
            <div
              v-if="tab == 'all' && main_tab == 'manager'"
              class="list-container"
            >
              <table class="table-data">
                <thead class="table-header">
                  <tr>
                    <th>Manager name</th>
                    <th>Privileges</th>
                    <th>Contacts</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody class="table-body">
                  <template v-for="(item, index) in user.managers">
                    <tr
                      :key="index"
                      :class="{ active: item.active }"
                      class="row-data"
                    >
                      <td @click="viewItem(item)">
                        <div class="profile-content center">
                          <img
                            class="profile-image"
                            v-if="item.profile_picture"
                            :src="
                              $fullUrl(
                                'images/profiles/' + item.profile_picture
                              )
                            "
                            alt
                          />

                          <div v-else class="profile-alphabet">
                            <span>{{
                              $nameInitials(
                                item.first_name + " " + item.last_name
                              ) | validate
                            }}</span>
                          </div>
                          <div class="names-location">
                            <label class="name"
                              >{{ item.first_name | validate }}
                              {{ item.last_name | validate }}</label
                            >
                            <span
                              class="location"
                              v-if="
                                item.profile &&
                                $validateData(item.profile.address)
                              "
                              >{{ item.profile.address | validate }}</span
                            >
                          </div>
                        </div>
                      </td>
                      <td @click="viewItem(item)">
                        <div class="roles">
                          <span
                            class="role-name"
                            :class="{ divider: item.roles.length - 1 > index }"
                            v-for="(role, index) in item.roles"
                            :key="index"
                            >{{ validateRoleName(role.name) }}</span
                          >
                        </div>
                      </td>
                      <td @click="viewItem(item)">
                        <div class="email-phone">
                          <span class="email">{{ item.email | validate }}</span>
                          <span class="phone" v-if="item.profile">{{
                            item.profile.phone | validate
                          }}</span>
                        </div>
                      </td>
                      <td>
                        <div class="menu">
                          <!-- Dropdown -->
                          <dropdown-menu>
                            <ul>
                              <li v-if="user.manager_info.id != item.id">
                                <a href @click.prevent="changePermission(item)"
                                  >Change Permission</a
                                >
                              </li>
                              <li>
                                <a
                                  href
                                  @click.prevent="manageConsultant(item.id)"
                                  >Manage Profile</a
                                >
                              </li>
                              <li v-if="user.manager_info.id != item.id">
                                <app-dialog
                                  title="Remove Manager"
                                  ask="Are you sure? This manager will be removed from any team in this organization and become normal consutant."
                                  yesText="Remove"
                                  noText="Cancel"
                                  @onComfirm="removeManager(item.id)"
                                >
                                  <a>Remove manager</a>
                                </app-dialog>
                              </li>
                            </ul>
                          </dropdown-menu>
                          <!-- End of dropdown -->
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <!-- End -->
          </div>

          <div
            class="empty-widget"
            v-if="
              tab == 'all'
                ? user.consultants.length == 0
                : user.available_consultants.length == 0 &&
                  main_tab == 'consultant'
            "
          >
            <div class="empty-widget-body">
              <p>
                You have not yet added consultants,
                <br />Click below to add one
              </p>
              <button class="add-btn" @click="addMember()">Add a member</button>
            </div>
          </div>
        </div>
        <multipane-resizer></multipane-resizer>
        <div
          class="item-view-more"
          :style="{ flexGrow: 1 }"
          v-if="consultant_item"
        >
          <div class="consultants-item">
            <div class="consultants-item-header">
              <div class="consultants-item-brand">
                <img
                  v-if="consultant_item.profile_picture"
                  :src="
                    $fullUrl(
                      'images/profiles/' + consultant_item.profile_picture
                    )
                  "
                  alt
                />
                <img v-else src="@/assets/icons/logo_avatar.svg" alt />
              </div>
              <div class="content">
                <div class="title-row">
                  <label
                    >{{ consultant_item.first_name | validate }}
                    {{ consultant_item.last_name | validate }}</label
                  >
                  <span v-if="consultant_item.profile.address">{{
                    consultant_item.profile.address | validate
                  }}</span>
                </div>

                <button class="close-btn" @click="showConsultants()">
                  <span>&times;</span>
                </button>
                <div class="options">
                  <div
                    class="date-widget"
                    v-if="
                      $validateDateTime(consultant_item.profile.available_from)
                    "
                  >
                    <div class="date-text">
                      {{ consultant_item.profile.available_from | formatDate }}
                    </div>
                  </div>
                  <div class="status" v-else>Not Available</div>
                </div>
              </div>
            </div>
            <div class="consultants-item-body">
              <div class="consultants-info">
                <h5 v-if="$validateData(consultant_item.profile.phone)">
                  Telephone
                </h5>
                <p>{{ consultant_item.profile.phone | validate }}</p>
                <h5 v-if="$validateData(consultant_item.email)">E-mail</h5>
                <p>{{ consultant_item.email | validate }}</p>
                <h5 v-if="$validateData(consultant_item.profile.description)">
                  Description
                </h5>
                <div
                  class="description"
                  v-html="consultant_item.profile.description"
                ></div>
                <h5>Skills</h5>
                <div class="skills-widget">
                  <div class="skills_content__wrapper">
                    <div class="skill_box">
                      <div class="skill_box_header">
                        <label>Tools</label>
                      </div>
                      <div
                        class="skill_box_body"
                        v-if="consultant_item.skills.tools.length > 0"
                      >
                        <div
                          class="row__item"
                          v-for="(
                            value, i
                          ) in consultant_item.skills.tools.slice(0, 5)"
                          :key="i"
                        >
                          <span>{{ value.name | validate }}</span>
                          <star-rating
                            inactive-color="#C1C1C1"
                            :read-only="true"
                            active-color="#1BA5A4"
                            :star-size="14"
                            :show-rating="false"
                            v-model="value.level"
                          ></star-rating>
                        </div>
                      </div>
                      <div class="skill_box_body" v-else>
                        <div class="empty-skills">
                          <p>Have not added any tool yet.</p>
                        </div>
                      </div>
                    </div>
                    <div class="skill_box">
                      <div class="skill_box_header">
                        <label>Domains</label>
                      </div>
                      <div
                        class="skill_box_body"
                        v-if="consultant_item.skills.domains.length > 0"
                      >
                        <div
                          class="row__item"
                          v-for="(
                            value, i
                          ) in consultant_item.skills.domains.slice(0, 5)"
                          :key="i"
                        >
                          <span>{{ value.name | validate }}</span>
                          <star-rating
                            inactive-color="#C1C1C1"
                            :read-only="true"
                            active-color="#1BA5A4"
                            :star-size="14"
                            :show-rating="false"
                            v-model="value.level"
                          ></star-rating>
                        </div>
                      </div>
                      <div class="skill_box_body" v-else>
                        <div class="empty-skills">
                          <p>Have not added any domain yet.</p>
                        </div>
                      </div>
                    </div>
                    <div class="skill_box">
                      <div class="skill_box_header">
                        <label>Languages</label>
                      </div>
                      <div
                        class="skill_box_body"
                        v-if="consultant_item.skills.languages.length > 0"
                      >
                        <div
                          class="row__item"
                          v-for="(
                            value, i
                          ) in consultant_item.skills.languages.slice(0, 5)"
                          :key="i"
                        >
                          <span>{{ value.lang.name | validate }}</span>
                          <star-rating
                            inactive-color="#C1C1C1"
                            :read-only="true"
                            active-color="#1BA5A4"
                            :star-size="14"
                            :show-rating="false"
                            v-model="value.level"
                          ></star-rating>
                        </div>
                      </div>
                      <div class="skill_box_body" v-else>
                        <div class="empty-skills">
                          <p>Have not added any language yet.</p>
                        </div>
                      </div>
                    </div>

                    <div class="skill_box">
                      <div class="skill_box_header">
                        <label>Roles</label>
                      </div>
                      <div
                        class="skill_box_body"
                        v-if="consultant_item.skills.roles.length > 0"
                      >
                        <div
                          class="row__item"
                          v-for="(
                            value, i
                          ) in consultant_item.skills.roles.slice(0, 5)"
                          :key="i"
                        >
                          <span>{{ value.name | validate }}</span>
                          <star-rating
                            inactive-color="#C1C1C1"
                            :read-only="true"
                            active-color="#1BA5A4"
                            :star-size="14"
                            :show-rating="false"
                            v-model="value.level"
                          ></star-rating>
                        </div>
                      </div>
                      <div class="skill_box_body" v-else>
                        <div class="empty-skills">
                          <p>Have not added any role yet.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="next_skills_content__wrapper">
                    <div class="skill_box">
                      <div class="skill_box_header">
                        <label>Competences</label>
                      </div>
                      <div
                        class="skill_box_body"
                        v-if="consultant_item.skills.competences.length > 0"
                      >
                        <div
                          class="row__item"
                          v-for="(
                            value, i
                          ) in consultant_item.skills.competences.slice(0, 5)"
                          :key="i"
                        >
                          <span>{{ value.name | validate }}</span>
                          <star-rating
                            inactive-color="#C1C1C1"
                            :read-only="true"
                            active-color="#1BA5A4"
                            :star-size="14"
                            :show-rating="false"
                            v-model="value.level"
                          ></star-rating>
                        </div>
                      </div>
                      <div class="skill_box_body" v-else>
                        <div class="empty-skills">
                          <p>Have not added any competence yet.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="consultants-item-body-option"></div>
            </div>
          </div>
        </div>
        <div class="item-view-more" :style="{ flexGrow: 1 }" v-else>
          <div class="empty-widget">
            <h1>No consultant or manager selected</h1>
          </div>
        </div>
      </multipane>
    </div>
    <!-- End -->

    <!-- Member management -->
    <div class="member-management" v-show="member_management_modal == true">
      <div class="member-container" v-if="!request_sent">
        <div class="member-header">
          <h3>Add consultants to manage</h3>
        </div>
        <div class="team-widget">
          <label>Select Team</label>
          <select class="input-form" v-model="selected_team_id">
            <option
              v-for="(team, index) in department_data"
              :key="index"
              :value="team.id"
            >
              {{ team.name }}
            </option>
          </select>
        </div>
        <div class="member-search-widget">
          <div class="search-container">
            <img src="@/assets/icons/search.svg" alt />
            <input
              type="text"
              placeholder="Type in to Search…"
              v-model="search_consultant_member"
            />
          </div>
          <div
            v-show="
              getSearchedPeople &&
              getSearchedPeople.length &&
              search_consultant_member
            "
            class="search_dropdown__body"
          >
            <div
              class="dropdown__item"
              v-for="(person, i) in getSearchedPeople"
              :key="i"
              @click="addMate(person)"
            >
              <img
                v-if="person.profile_picture"
                :src="$fullUrl('images/profiles/' + person.profile_picture)"
                alt="picture"
              />
              <img v-else src="@/assets/avatar.png" alt />
              <div class="text">
                <span>{{
                  (person.first_name + " " + person.last_name) | validate
                }}</span>
              </div>
            </div>
          </div>
          <span>Or</span>
          <div class="invite-option">
            <button class="invite-btn">Invite via Email</button>
          </div>
        </div>
        <div class="member-body" v-if="added_member_list.length > 0">
          <!-- <label
            class="member-body-title"
          >The manager is paying monthly 1 USD For every consultants selected to manage.</label>-->
          <label class="member-body-title"
            >Consultants selected to manage.</label
          >
          <div class="member-fieldset">
            <div class="collaboraters-widget">
              <div class="item" v-for="(item, i) in added_member_list" :key="i">
                <img
                  v-if="item.picture"
                  :src="$fullUrl('images/profiles/' + item.picture)"
                  alt="picture"
                  class="profile-img"
                />
                <img v-else src="@/assets/avatar.png" alt class="profile-img" />
                <span class="name">{{ item.names | validate }}</span>
                <button class="remove-member-btn" @click="removeMate(i)">
                  <img src="@/assets/icons/close.svg" />
                </button>
              </div>
            </div>
          </div>
          <label class="sectected-member-count"
            >{{ added_member_list.length | validate }} Consultants
            selected</label
          >
        </div>
        <div class="member-body" v-else>
          <label class="member-body-title"
            >No consultants selected to manage.</label
          >
        </div>
        <div class="member-managment-option">
          <consultfied-button
            v-if="added_member_list.length > 0"
            @click="addConsultants()"
            class="btn-save"
            :loading="company_add_member_loading"
            >Done</consultfied-button
          >

          <button class="btn-back" @click="showConsultants()">Close</button>
        </div>
      </div>
      <div v-else class="member-container">
        <div>
          Request was sent, Wait until selected
          {{ added_member_list.length > 1 ? "members" : "member" }} approves
          your request.
        </div>
        <div class="member-managment-option">
          <button class="btn-back" @click="showConsultants()">Ok</button>
        </div>
      </div>
    </div>
    <!-- End Member management -->

    <!-- Invite Manager Modal -->
    <div class="invite-manager-overlay" v-if="show_invite_manager_modal">
      <div class="invite-manager-modal">
        <div class="invite-manager-header">
          <div class="title" v-if="!manager_form.change">
            Invite a new Manager
          </div>
          <div class="title" v-else>Change Permission</div>
          <div class="company-info" v-if="!manager_form.change">
            <img
              class="profile-logo"
              v-if="!$getLoggedUser().company_logo"
              :src="
                $fullUrl('images/profiles/' + $getLoggedUser().company_logo)
              "
            />
            <img
              v-else
              class="profile-logo"
              src="@/assets/icons/logo_avatar.svg"
            />
            <h3 class="company-name">{{ $getLoggedUser().company_name }}</h3>
          </div>
          <div class="company-info" v-else>
            <img
              class="profile-logo"
              v-if="consultant_item.profile_picture"
              :src="
                $fullUrl('images/profiles/' + consultant_item.profile_picture)
              "
              alt
            />
            <img
              class="profile-logo"
              v-else
              src="@/assets/icons/logo_avatar.svg"
              alt
            />

            <h3 class="company-name">
              {{ consultant_item.first_name | validate }}
              {{ consultant_item.last_name | validate }}
            </h3>
          </div>
        </div>
        <div class="invite-manager-body">
          <h2>Please Select Manager Type</h2>
          <div class="permition-widget">
            <template v-for="(item, index) in manager_perms">
              <div
                class="permition-item"
                :key="index"
                v-if="item.value == 'consultant' && manager_form.change == true"
              >
                <div class="permition-header">
                  <input
                    type="radio"
                    v-model="manager_form.permt_type"
                    name="permit"
                    :value="item.value"
                    :id="'permt_item_id_' + index"
                  />
                  <label :for="'permt_item_id_' + index">{{
                    item.label
                  }}</label>
                </div>
                <div
                  class="permition-body"
                  v-if="manager_form.permt_type == item.value"
                >
                  {{ item.description }}
                </div>
              </div>
              <div
                class="permition-item"
                :key="index"
                v-else-if="item.value != 'consultant'"
              >
                <div class="permition-header">
                  <input
                    type="radio"
                    v-model="manager_form.permt_type"
                    name="permit"
                    :value="item.value"
                    :id="'permt_item_id_' + index"
                  />
                  <label :for="'permt_item_id_' + index">{{
                    item.label
                  }}</label>
                </div>
                <div
                  class="permition-body"
                  v-if="manager_form.permt_type == item.value"
                >
                  {{ item.description }}
                </div>
              </div>
            </template>
          </div>
          <div class="options">
            <c-button
              :loading="invite_manager_loading"
              @click="inviteAsManager()"
              class="btn-submit"
              >Accept</c-button
            >
            <button
              @click="show_invite_manager_modal = false"
              class="btn-close"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- End of invite manager modoal -->
  </div>
</template>

<script>
import panelExpand from "@/components/Partials/panelExpand";
import appDialog from "@/components/Dialog/AppDialog.vue";
import consultfiedButton from "@/components/helper/consultfiedButton.vue";
import { eventBus } from "@/main";
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
export default {
  name: "consultants",
  components: {
    panelExpand,
    appDialog,
    consultfiedButton,
    draggable,
  },
  props: {},
  data: () => {
    return {
      request_sent: false,
      member_management_modal: false,
      consultant_list: true,
      tab: "all",
      main_tab: "consultant",
      manage_consultant_component: false,
      search_consultant_member: "",
      added_member_list: [],
      selected_team_id: "",
      company_add_member_loading: false,
      user: {
        company_info: {},
        manager_info: {},
        manager_profile: {},
        consultants: [],
      },
      search_member_input: "",
      selected_id: null,
      consultant_item: null,
      manager_perms: [
        {
          label: "Admin Manager",
          value: "super-manager",
          checked: false,
          description:
            "As Admin Manager, one will access full control and administration of the organization.",
        },
        {
          label: "Division Manager",
          value: "department-manager",
          checked: false,
          description:
            "As Division Department Manager, one will access departments control and teams administration in the department. They will be able to manager consultants profiles, create leads, invite consultants and managers however, some of the features requires the Super Manager approval.",
        },
        {
          label: "Team Manager",
          value: "team-manager",
          checked: false,
          description:
            "As Team Manager, one will access only team control. They will be developing and carrying out management process. They will be able to manage consultants profiles, create leads, invite consultants with the Super Manager approval.",
        },
        {
          label: "Consultant",
          value: "consultant",
          checked: false,
          description:
            "As A Consultant, one will only managed by different managers",
        },
      ],
      manager_form: {
        change: false,
        permt_type: null,
        company_id: null,
        user_id: null,
      },
      show_invite_manager_modal: false,
      invite_manager_loading: false,
      department_data: [],
      selected_view_filter: "",
      view_filter: [
        {
          value: "all",
          name: "All",
        },
        {
          value: "avail",
          name: "Available",
        },
      ],
    };
  },
  mounted() {
    let vm = this;
    vm.getAllStartData();
    vm.getTeamDepData();
  },
  computed: {
    ...mapGetters(["getSearchedPeople"]),
  },
  watch: {
    search_consultant_member: function (query) {
      this.searchPeople(query);
    },
    selected_view_filter(val) {
      let vm = this;
      vm.tab = val;
    },
  },
  methods: {
    validateRoleName(name) {
      if (name == "super-manager") {
        return "Admin manager";
      } else if (name == "team-manager") {
        return "Team manager";
      } else if (name == "department-manager") {
        return "Division manager";
      }
    },
    changePermission(item) {
      let vm = this;
      vm.manager_form.company_id = vm.user.company_info.id;
      vm.manager_form.user_id = item.id;
      vm.manager_form.permt_type = item.roles;
      vm.manager_form.change = true;
      vm.show_invite_manager_modal = true;
      vm.consultant_item = item;
    },
    removeManager(id) {
      let vm = this;
      vm.$store
        .dispatch("REMOVE_MANAGER_FROM_COMPANY", {
          company_id: vm.user.company_info.id,
          user_id: id,
        })
        .then((responce) => {
          vm.getAllStartData();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    checkPermission({ target }, item) {
      let vm = this;
      if (target.checked) {
        item.checked = true;
        vm.manager_form.permt_type.push(item.value);
      } else {
        item.checked = false;
        const index = vm.manager_form.permt_type.indexOf(item.value);
        if (index > -1) {
          vm.manager_form.permt_type.splice(index, 1);
        }
      }
    },
    getTeamDepData() {
      let vm = this;
      vm.$store
        .dispatch("GET_ALL_USER_INFO")
        .then((response) => {
          response.data.forEach((item) => {
            item.teams.forEach((team) => {
              vm.department_data.push(team);
            });
          });
        })
        .catch((error) => {
          console.error({ error });
        });
    },
    showinviteManagerModal(id) {
      let vm = this;
      vm.manager_form.company_id = vm.user.company_info.id;
      vm.manager_form.user_id = id;
      vm.manager_form.change = false;
      vm.show_invite_manager_modal = true;
    },
    inviteAsManager() {
      let vm = this;
      vm.invite_manager_loading = true;
      if (!vm.manager_form.change) {
        vm.$store
          .dispatch("COMPANY_INVITE_CONSULTANT_AS_MANAGER", vm.manager_form)
          .then((responce) => {
            vm.invite_manager_loading = false;
            vm.show_invite_manager_modal = false;
            vm.getAllStartData();
            vm.$notify({
              group: "status",
              title: "Message",
              text: "Now invite was sent",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.invite_manager_loading = false;
            vm.$notify({
              group: "status",
              title: "Something wrong",
              text: "Invite not sent, Please try again.",
              type: "warn",
              duration: 3000,
            });
            console.log(error);
          });
      } else {
        vm.$store
          .dispatch("COMPANY_CONSULTANT_CHANGE_PERMISSION", vm.manager_form)
          .then((responce) => {
            vm.invite_manager_loading = false;
            vm.show_invite_manager_modal = false;
            vm.getAllStartData();
            vm.$notify({
              group: "status",
              title: "Message",
              text: "Permission was changed",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.invite_manager_loading = false;
            vm.$notify({
              group: "status",
              title: "Something wrong",
              text: "Permission not set, Please try again.",
              type: "warn",
              duration: 3000,
            });
            console.log(error);
          });
      }
    },
    viewItem(item) {
      let vm = this;
      vm.user.consultants.forEach((item) => {
        eventBus.$set(item, "active", false);
        return item;
      });
      vm.user.managers.forEach((item) => {
        eventBus.$set(item, "active", false);
        return item;
      });
      vm.user.available_consultants.forEach((item) => {
        eventBus.$set(item, "active", false);
        return item;
      });
      item.active = true;
      vm.consultant_item = item;
    },
    searchCompanyMember() {
      let vm = this;
      let query = vm.search_member_input;
      if (vm.search_member_input) {
        vm.$store
          .dispatch("SEARCH_FOR_COMPANY_MEMBERS", { query: query })
          .then((responce) => {
            let consultant_data = vm.processSkills(responce.data);
            eventBus.$set(vm.user, "consultants", consultant_data);
            vm.user.consultants = vm.user.consultants
              .filter((item) => {
                return item.profile;
              })
              .sort((start, end) => {
                return start.order - end.order;
              });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        vm.getAllStartData();
      }
    },
    getAllStartData() {
      let vm = this;
      vm.$store
        .dispatch("GET_ME_USER_COMPANY")
        .then((responce) => {
          vm.user = responce.data;

          // Consultant list
          let consultant_data = vm.processSkills(vm.user.consultants);
          eventBus.$set(vm.user, "consultants", consultant_data);
          vm.user.consultants.forEach((item) => {
            eventBus.$set(item, "active", false);
            return item;
          });
          vm.user.consultants = vm.user.consultants
            .filter((item) => {
              return item.profile;
            })
            .sort((start, end) => {
              return start.order - end.order;
            });

          // Available consultant list
          let available_consultants = vm.processSkills(
            vm.user.available_consultants
          );
          eventBus.$set(
            vm.user,
            "available_consultants",
            available_consultants
          );
          vm.user.available_consultants.forEach((item) => {
            eventBus.$set(item, "active", false);
            return item;
          });
          vm.user.available_consultants = vm.user.available_consultants
            .filter((item) => {
              return item.profile;
            })
            .sort((start, end) => {
              return start.order - end.order;
            });
          if (window.innerWidth > 500) {
            if (vm.user.consultants.length > 0) {
              vm.viewItem(vm.user.consultants[0]);
            }
          }

          // Manager
          let managers = vm.processSkills(vm.user.managers);
          eventBus.$set(vm.user, "managers", managers);
          vm.user.managers.forEach((item) => {
            eventBus.$set(item, "active", false);
            return item;
          });
        })
        .catch((error) => {});
    },
    removeConsultant(item) {
      let vm = this;
      vm.$store
        .dispatch("REMOVE_MEMBER_FROM_COMPANY", {
          company_id: vm.user.company_info.id,
          user_id: item.id,
          account_type: item.account_type,
        })
        .then((responce) => {
          vm.getAllStartData();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    processSkills(consultants) {
      return consultants.map((item) => {
        let skills = {
          tools: [],
          domains: [],
          languages: [],
          competences: [],
          roles: [],
        };
        if (item.skills.length && item.skills.length > 0) {
          item.skills.forEach((skill) => {
            skill.tools.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.tools.push(obj);
            });
            skill.domains.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.domains.push(obj);
            });
            skill.competences.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.competences.push(obj);
            });
            skill.roles.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.roles.push(obj);
            });
            skill.languages.forEach((item) => {
              if (item.lang) {
                let obj = {
                  lang: { name: item.lang.name },
                  level: parseInt(item.level),
                };
                skills.languages.push(obj);
              }
            });
          });
        }
        eventBus.$set(item, "skills", skills);
        return item;
      });
    },
    addConsultants() {
      let vm = this;
      vm.company_add_member_loading = true;
      vm.request_sent = false;
      let data = vm.added_member_list.map((item) => {
        return item.id;
      });
      vm.$store
        .dispatch("ADD_COMPANY_MEMBER", {
          members_added: data,
          crm_team_id: vm.selected_team_id,
        })
        .then((responce) => {
          vm.company_add_member_loading = false;
          vm.request_sent = true;
        })
        .catch((error) => {
          vm.company_add_member_loading = false;
        });
    },
    removeMate(i) {
      let vm = this;
      vm.added_member_list.splice(i, 1);
    },
    addMate(member) {
      let vm = this;
      let obj = {
        id: member.id,
        names: member.first_name + " " + member.last_name,
        picture: member.profile_picture,
      };
      if (!vm.added_member_list.map((item) => item.id).includes(member.id)) {
        vm.added_member_list.push(obj);
        vm.search_consultant_member = "";
      } else {
        vm.$notify({
          group: "status",
          title: "Something wrong",
          text: "Already selected, Please try other.",
          type: "warn",
          duration: 3000,
        });
      }
    },
    searchPeople(query) {
      this.$store.dispatch("SEARCH_FOR_PROJECT_MEMBERS", { query: query });
    },
    onCloseManageConsultant() {
      let vm = this;
      vm.selected_id = null;
      vm.manage_consultant_component = false;
      vm.member_management_modal = false;
      vm.consultant_list = true;
      vm.getAllStartData();
    },
    manageConsultant(id) {
      let vm = this;
      vm.$router.push({
        name: "manage_consultant",
        params: { id: id, company_id: vm.user.company_info.id },
      });
    },
    addMember() {
      let vm = this;
      vm.member_management_modal = true;
      vm.consultant_list = true;
      vm.manage_consultant_component = false;
    },
    showConsultants() {
      let vm = this;
      vm.consultant_item = null;
      vm.member_management_modal = false;
      vm.consultant_list = true;
      vm.manage_consultant_component = false;
      vm.request_sent = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.company-profile-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .company-profile-container {
    padding: 1px;
    width: 100%;
    position: relative;
    height: 100%;
    .custom-resizer {
      height: 100%;
    }
    .items {
      height: 100%;
      overflow-y: auto;
      min-width: 300px;
      width: 100%;
      background: #ffffff;
      border-radius: 5px;
      .company-profile-body {
        border-radius: 5px;
        background: #fff;
        .tabs {
          display: grid;
          grid-template-columns: 50% 50%;
          .tab:nth-child(1) {
            border-top-left-radius: 5px;
          }
          .tab:nth-child(2) {
            border-top-right-radius: 5px;
          }
          .tab {
            background: #cccccc;
            height: 55px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: 200ms ease-in-out;
            &.active {
              background: #fff;
              color: #1ba5a4;
              font-weight: 800;
              transition: 200ms ease-in-out;
              border-bottom: 2px solid #1ba5a4;
            }
            &:hover {
              color: #1ba5a4;
            }
          }
        }
        .consultants-item-header {
          display: flex;
          justify-content: space-between;
          padding: 24px 22px;
          .options {
            .add-btn {
              color: #1885ad;
              display: flex;
              font-style: italic;
              outline: none;
            }
          }
        }

        .search-add-btn-widget {
          background: #fff;
          padding: 20px 20px;
          display: grid;
          grid-template-columns: 100%;
          grid-column-gap: 20px;
          padding-bottom: 5px;
          .search-widget {
            border: 1px solid #ccc;
            height: 45px;
            display: flex;
            align-items: center;
            padding: 0px 10px;
            border-radius: 5px;
            img {
              width: 25px;
              height: 25px;
            }
            input {
              height: 42px;
              width: 100%;
              padding-left: 15px;
              outline: none;
              border: none;
            }
          }
        }
        .filter-widget {
          display: flex;
          padding: 0px 20px;
          .filter-select-widget {
            display: flex;
            align-items: center;
            cursor: pointer;
            .filter-selected-label {
              span {
                color: #0884af;
              }
            }
          }
        }

        ul.consultants-items {
          background: #ffffff;
          padding: 0px 20px;
          padding-bottom: 20px;
          list-style: none;
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          margin: 0px;
          .consultants-starter {
            margin-bottom: 6px;
            .consultants-item-header {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 16px 0px;
              label {
                color: #000000;
                font-family: "AvenirBook";
                font-size: 16px;
              }
              .btn-add-assignment {
                color: #1ba5a4;
                border: none;
                padding: 10px 10px;
                font-size: 14px;
                outline: none;
                cursor: pointer;
                font-family: "AvenirBook";
                font-style: italic;
                background: transparent;
              }
            }
            p {
              color: #131313;
              font-family: "AvenirBook";
            }
          }
          .consultants-item {
            background: #f5f5f5;
            border-radius: 5px;
            margin-bottom: 10px;
            position: relative;
            cursor: pointer;
            :hover {
              background: rgb(248, 248, 248);
              border-radius: 5px;
            }
            &.active {
              border: 1px solid #1ba5a4;
              background: rgb(248, 248, 248);
            }
            .consultants-item-header {
              display: grid;
              padding: 10px 10px;
              grid-template-columns: 65px calc(97% - 65px);
              grid-column-gap: 5px;
              @media (min-width: 300px) and (max-width: 630px) {
                grid-template-columns: 60px calc(98% - 60px);
                grid-column-gap: 5px;
                padding: 10px 10px;
              }
              .consultants-item-brand {
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                  width: 50px;
                  height: 50px;
                  object-fit: cover;
                  border-radius: 50%;
                  border: 0px solid rgb(228, 228, 228);
                  @media (min-width: 300px) and (max-width: 630px) {
                    width: 33px;
                    height: 33px;
                  }
                }
              }
              .content {
                display: flex;
                justify-content: space-between;
                width: 100%;
                align-items: center;
                padding-right: 5px;
                .title-row {
                  font-family: "AvenirBook";
                  display: flex;
                  flex-direction: column;
                  label {
                    display: block;
                    font-size: 14px;
                    font-family: "AvenirBook";
                    margin-bottom: 1px;
                    font-weight: 500;
                  }

                  span {
                    color: #808080;
                    font-family: "AvenirBook";
                    font-size: 13px;
                    margin-bottom: 0px;
                  }
                  .date {
                    color: #808080;
                    font-family: "AvenirBook";
                    font-size: 12px;
                  }
                }
                .options {
                  display: flex;
                  flex-direction: column;
                  align-items: flex-end;
                  .roles {
                    margin-top: 10px;
                    .role-name {
                      color: #0884af;
                      &.divider {
                        border-right: 1px solid #0884af;
                        padding-right: 8px;
                        margin-right: 8px;
                      }
                    }
                  }
                  .status {
                    color: #000;
                    font-family: "AvenirBook";
                    font-size: 13px;
                  }
                  .toogle-panel-btn {
                    width: 19px;
                    padding: 0;
                    height: 22px;
                    font-size: 20px;
                    position: absolute;
                    bottom: 10px;
                    right: 10px;
                    @media (min-width: 300px) and (max-width: 630px) {
                      right: 10px;
                    }
                    img {
                      width: 13px;
                    }
                  }
                }
              }
              .toogle-panel-btn {
                padding: 1px 40px;
                font-size: 30px;
                background: transparent;
                border: none;
                outline: none;
                cursor: pointer;
                color: #ccc;
              }
            }
          }
        }
        .list-container {
          padding: 0px 20px;
          padding-bottom: 20px;
          .table-data {
            border-collapse: collapse;
            border-spacing: 0;
            tr {
              &.row-data {
                background: #efefef;
              }
              &:hover {
                background: rgb(248, 248, 248);
                cursor: pointer;
              }
              &.active {
                background: rgb(248, 248, 248);
              }

              th {
                border-bottom: none;
                padding: 10px 3px !important;
                &.center {
                  display: flex;
                  align-content: center;
                  input {
                    position: relative;
                    top: 0px;
                    margin-right: 5px;
                    margin: 0px 20px;
                  }
                }
                &.text-center {
                  text-align: center;
                }
              }
              td {
                .checkbox {
                  margin: 0px 20px;
                }
                .profile-content {
                  .profile-alphabet {
                    margin-right: 5px;
                    height: 30px !important;
                    width: 30px !important;
                    background: #1ba5a4;
                    span {
                      font-size: 10px;
                      color: #fff;
                    }
                  }
                  .names-location {
                    display: flex;
                    flex-direction: column;
                    .name {
                      font-size: 13px;
                    }
                    .location {
                      font-size: 12px;
                      color: #707070;
                    }
                  }
                  .profile-image {
                    margin-right: 5px;
                    height: 30px !important;
                    width: 30px !important;
                    border-radius: 50%;
                    object-fit: cover;
                  }
                }

                .email-phone {
                  display: flex;
                  flex-direction: column;
                  .email {
                    font-size: 13px;
                  }
                  .phone {
                    font-size: 12px;
                    color: #707070;
                  }
                }

                .menu {
                  width: 100%;
                  display: flex;
                  justify-content: center;
                  button {
                    padding: 0px;
                    position: relative;
                    left: -3px;
                    img {
                      width: 15px;
                    }
                  }
                }
                &:first-child {
                  border-top-left-radius: 5px;
                  border-bottom-left-radius: 5px;
                }
                &:last-child {
                  border-top-right-radius: 5px;
                  border-bottom-right-radius: 5px;
                }
                text-align: left;
                border-bottom: none;
                padding: 8px 3px;
                font-size: 13px;
                color: rgb(28, 28, 28);
                border-bottom: 5px solid #fff;
                &.center {
                  text-align: center;
                }
              }
            }
          }
        }
      }

      .empty-widget {
        padding: 0px 20px;
        .empty-widget-body {
          height: 350px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          padding: 0px 0px;
          p {
            text-align: center;
            width: 300px;
          }
          .add-btn {
            width: 180px;
            height: 45px;
            background: #1890a9 0% 0% no-repeat padding-box;
            border-radius: 4px;
            color: #fff;
            outline: none;
            margin-right: 20px;
            display: center;
            justify-content: center;
          }
        }
      }
    }
    .item-view-more {
      height: 100%;
      overflow-y: auto;
      padding: 15px;
      padding-bottom: 40px;
      background: #fff;
      border-radius: 5px;
      width: 400px;
      min-width: 400px;
      max-width: 100%;
      @media (min-width: 300px) and (max-width: 630px) {
        position: fixed;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        z-index: 999999;
        display: flex;
        justify-content: center;
        padding-right: 0px;
        background: #fff;
      }
      .empty-widget {
        display: flex;
        align-content: center;
        justify-content: center;
        h1 {
          font-size: 20px;
          color: #ddd;
          margin-top: 200px;
        }
      }
      .consultants-item {
        background: #ededed;
        border-radius: 5px;
        margin-bottom: 10px;
        position: relative;
        @media (min-width: 300px) and (max-width: 630px) {
          padding-top: 40px;
        }
        .consultants-item-header {
          display: grid;
          padding-top: 25px;
          padding-right: 25px;
          padding-left: 25px;
          grid-template-columns: 65px calc(97% - 65px);
          grid-column-gap: 5px;
          @media (min-width: 300px) and (max-width: 630px) {
            grid-template-columns: 60px calc(98% - 60px);
            grid-column-gap: 5px;
            padding: 10px 17px;
            position: fixed;
            top: 0px;
            left: 0px;
            right: 0px;
            background: #fff;
          }
          .consultants-item-brand {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            img {
              width: 50px;
              height: 50px;
              object-fit: cover;
              border-radius: 50%;
              border: 0px solid rgb(228, 228, 228);
              @media (min-width: 300px) and (max-width: 630px) {
                width: 33px;
                height: 33px;
              }
            }
          }
          .content {
            display: flex;
            justify-content: space-between;
            width: 100%;
            align-items: center;
            padding-right: 5px;
            .title-row {
              font-family: "AvenirBook";
              label {
                display: block;
                font-size: 16px;
                font-family: "AvenirBook";
                margin-bottom: 1px;
                font-weight: 500;
              }
              span {
                color: #808080;
                font-family: "AvenirBook";
                font-size: 13px;
                margin-bottom: 6px;
              }
              .date {
                color: #808080;
                font-family: "AvenirBook";
                font-size: 13px;
              }
            }
            .close-btn {
              display: none;
              @media (min-width: 300px) and (max-width: 630px) {
                display: block;
                span {
                  font-size: 24px;
                }
              }
            }
            .options {
              display: flex;
              flex-direction: column;
              .date-widget {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                .date-label {
                  color: #1ba5a4;
                }
              }
            }
          }
          .toogle-panel-btn {
            padding: 1px 40px;
            font-size: 30px;
            background: transparent;
            border: none;
            outline: none;
            cursor: pointer;
            color: #ccc;
          }
        }
        .consultants-item-body {
          padding-bottom: 25px;
          padding-right: 25px;
          padding-left: 25px;
          .consultants-info {
            h5 {
              text-align: left;
              color: #6e6e6e;
              font-size: 14px;
              margin-bottom: 0px;
            }
            p {
              font-family: "AvenirBook";
              text-align: left;
              color: #000;
              font-size: 15px;
              font-weight: 800;
              margin-top: 4px;
            }
            .description {
              margin-top: -8px;
              font-family: "AvenirBook";
              p {
                font-size: 15px !important;
              }
            }
            .skills-widget {
              margin-top: 5px;
              .skills_content__wrapper {
                display: grid;
                grid-template-columns: 1fr 1fr;
                grid-gap: 10px;
                margin-bottom: 10px;
                @media (min-width: 300px) and (max-width: 630px) {
                  grid-template-columns: 1fr;
                }
                .skill_box {
                  min-width: 0;
                  display: flex;
                  flex-direction: column;
                  width: 100%;
                  background: #fff;
                  border-radius: 5px;

                  .skill_box_header {
                    border-bottom: 2px solid #f5f5f5;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    padding: 0px 15px;
                    label {
                      color: #0884af;
                      width: 100%;
                      font-size: 15px;
                      font-weight: 800;
                    }
                  }
                  .skill_box_body {
                    padding: 0px 15px;
                    .empty-skills {
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      min-height: 80px;
                      justify-content: center;
                      p {
                        text-align: center;
                        margin-bottom: 20px;
                        color: #8d8d8d;
                      }
                      button {
                        width: 133px;
                        height: 36px;
                        background: #1890a9 0% 0% no-repeat padding-box;
                        border-radius: 5px;
                        color: #fff;
                      }
                    }
                    .row__item {
                      margin-top: 10px;
                      display: flex;
                      margin-bottom: 10px;
                      justify-content: space-between;
                      width: 100%;
                      span {
                        color: #000000;
                        font-weight: normal;
                        margin-top: 2px;
                        font-size: 12px;
                        font-weight: 800;
                        overflow: hidden;
                        text-decoration: none;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        text-transform: capitalize;
                      }
                    }
                  }
                }
              }
              .next_skills_content__wrapper {
                display: grid;
                grid-template-columns: 1fr;
                grid-gap: 10px;
                @media (min-width: 300px) and (max-width: 630px) {
                  grid-template-columns: 1fr;
                }
                .skill_box {
                  min-width: 0;
                  display: flex;
                  flex-direction: column;
                  width: 100%;
                  background: #fff;
                  border-radius: 5px;
                  margin-bottom: 15px;
                  .skill_box_header {
                    border-bottom: 2px solid #f5f5f5;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    padding: 0px 15px;
                    label {
                      color: #0884af;
                      width: 100%;
                      font-size: 15px;
                      font-weight: 800;
                    }
                  }
                  .skill_box_body {
                    padding: 0px 15px;
                    .empty-skills {
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      min-height: 80px;
                      justify-content: center;
                      p {
                        text-align: center;
                        margin-bottom: 20px;
                        color: #8d8d8d;
                      }
                      button {
                        width: 133px;
                        height: 36px;
                        background: #1890a9 0% 0% no-repeat padding-box;
                        border-radius: 5px;
                        color: #fff;
                      }
                    }
                    .row__item {
                      margin-top: 10px;
                      display: flex;
                      margin-bottom: 10px;
                      justify-content: space-between;
                      width: 100%;
                      span {
                        color: #000000;
                        font-weight: normal;
                        margin-top: 2px;
                        font-size: 12px;
                        font-weight: 800;
                        overflow: hidden;
                        text-decoration: none;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        text-transform: capitalize;
                      }
                    }
                  }
                }
              }
            }
          }
          .consultants-item-body-option {
            display: flex;
            justify-content: flex-end;
            .toogle-panel-btn {
              padding: 1px 9px;
              font-size: 30px;
              background: transparent;
              border: none;
              outline: none;
              cursor: pointer;
              color: #ccc;
              height: 36px;
              width: 19px;
              padding: 0;
              height: 22px;
              font-size: 20px;
              position: relative;
              top: -3px;
              right: -5px;
            }
          }
        }
      }
    }
  }

  .member-management {
    width: 100%;
    padding-right: 15px;
    position: fixed;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    background: rgba($color: #000000, $alpha: 0.6);
    padding-top: 100px;
    z-index: 999999999;
    .member-container {
      background: #fff;
      padding: 30px 30px;
      width: 100%;
      border-radius: 5px;
      width: 450px;
      display: block;
      margin: 0 auto;
      @media (min-width: 300px) and (max-width: 630px) {
        padding: 30px 20px;
      }
      .member-header {
        width: 100%;
        padding-bottom: 30px;
        h3 {
          font-size: 20px;
          margin: 0px;
        }
      }
      .team-widget {
        display: flex;
        flex-direction: column;
        .input-form {
          border: 1px solid rgb(185, 185, 185);
          height: 40px;
          margin-bottom: 10px;
          outline: none;
          border-radius: 5px;
        }
      }
      .member-search-widget {
        display: flex;
        align-items: center;
        grid-column-gap: 30px;
        padding-bottom: 30px;
        position: relative;
        @media (min-width: 300px) and (max-width: 630px) {
          grid-template-columns: 100%;
          grid-row-gap: 20px;
        }
        .search-container {
          border: 1px solid #ccc;
          height: 45px;
          width: 100%;
          display: flex;
          align-items: center;
          padding: 0px 10px;
          border-radius: 5px;

          img {
            width: 25px;
            height: 25px;
          }
          input {
            height: 42px;
            width: 100%;
            padding-left: 15px;
            outline: none;
          }
        }
        .search_dropdown__body {
          position: absolute;
          top: 45px;
          width: 100%;
          background: #fff;
          z-index: 999;
          box-shadow: 0px 4px 7px #ccc;
          height: 250px;
          overflow-y: auto;
          border-radius: 5px;
          .dropdown__item {
            display: flex;
            align-items: center;
            border-bottom: 1px solid #e8e8e8;
            padding: 20px 10px;
            cursor: pointer;
            &:hover {
              background: #e8e8e8;
            }
            img {
              height: 30px;
              width: 30px;
              object-fit: cover;
              margin-right: 15px;
              border-radius: 50%;
            }
            .text {
              span {
                font-size: 15px;
              }
            }
          }
        }
        .invite-option {
          display: flex;
          flex-direction: column;
          span {
            color: #b3b3b3;
            margin: 20px 0px;
          }
          .invite-btn {
            width: 127px;
            height: 45px;
            background: #1890a9 0% 0% no-repeat padding-box;
            border-radius: 4px;
            color: #fff;
            outline: none;
          }
        }
      }
      .member-body {
        .member-body-title {
          font-size: 12px;
          color: #031019;
        }
        .member-fieldset {
          border: 1px solid #c2c2c2;
          border-radius: 5px;
          padding: 15px;
          .collaboraters-widget {
            padding: 10px 0px;
            display: flex;
            flex-wrap: wrap;
            .item {
              background: #1ba5a4 0% 0% no-repeat padding-box;
              border-radius: 20px;
              display: flex;
              align-items: center;
              padding: 4px 4px;
              margin-right: 8px;
              margin-bottom: 8px;
              position: relative;
              .profile-img {
                width: 26px;
                height: 26px;
                border-radius: 50%;
                margin-right: 5px;
              }
              .name {
                color: #fff;
                margin-right: 10px;
              }
              .remove-member-btn {
                background: crimson;
                border-radius: 50%;
                height: 20px;
                width: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: -11px;
                right: -7px;
              }
            }
          }
        }
        .sectected-member-count {
          font-size: 14px;
          color: #6e6e6e;
          margin-top: 10px;
          display: block;
        }
      }
      .member-managment-option {
        padding-top: 20px;
        display: flex;
        justify-content: flex-start;
        .btn-save {
          width: 100px;
          height: 45px;
          background: #1890a9 0% 0% no-repeat padding-box;
          border-radius: 4px;
          color: #fff;
          outline: none;
          margin-right: 20px;
          display: center;
          justify-content: center;
        }
        .btn-back {
          height: 45px;
          border-radius: 4px;
          color: #1890a9;
          outline: none;
        }
      }
    }
  }

  .invite-manager-overlay {
    width: 100%;
    padding-right: 15px;
    position: fixed;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    background: rgba($color: #000000, $alpha: 0.6);
    padding-top: 100px;
    z-index: 999999999;
    .invite-manager-modal {
      background: rgb(236, 236, 236);
      padding: 30px 30px;
      width: 100%;
      border-radius: 5px;
      width: 600px;
      display: block;
      margin: 0 auto;
      @media (min-width: 300px) and (max-width: 630px) {
        padding: 30px 20px;
      }
      .invite-manager-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title {
          color: #0884af;
          font-size: 20px;
          font-weight: 800;
        }
        .company-info {
          display: flex;
          align-items: center;
          img {
            width: 40px;
            height: 40px;
            object-fit: cover;
            border-radius: 50%;
            margin-right: 6px;
          }
          .company-name {
            font-weight: 800;
            color: #0884af;
            font-size: 16px;
          }
        }
      }
      .invite-manager-body {
        background: #fff;
        border-radius: 5px;
        padding: 15px;
        h2 {
          font-size: 18px;
          color: #676767;
          margin: 0px;
        }
        .permition-widget {
          margin-top: 15px;
          .permition-item {
            margin-bottom: 20px;
            .permition-header {
              display: flex;
              align-items: center;
              input {
                margin-right: 15px;
                margin-top: -4px;
              }
            }
            .permition-body {
              padding-top: 10px;
              padding-left: 30px;
              color: #737373;
              font-style: italic;
            }
          }
        }
        .options {
          display: flex;
          .btn-submit {
            width: 148px;
            height: 40px;
            background: #1ba5a4;
            border-radius: 5px;
            color: #fff;
            margin-right: 22px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .btn-close {
            color: #1ba5a4;
          }
        }
      }
    }
  }
}

.input-flex {
  display: flex;
}
</style>